var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-body border-0 bg-light mb-5 py-5"},[_c('p',{staticClass:"text-center text-muted mb-0 py-5"},[_vm._v("Loading available times")])])
}]

export { render, staticRenderFns }